<nav class="toolbar navbar navbar-light">
    <form class="form-inline" autocomplete="off">
        <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
        <button type="button"
                class="btn btn-outline-success"
                [disabled]="!porcentajeTotalEsValido || tieneCamposVacios()"
                (click)="onSave()"
                title="Guardar">
            <i class="fa fa-save"></i> Guardar
        </button>
    </form>
</nav>



<div class="container-fluid container-list">   
    <app-porcentajesemanal-list-edit *ngIf="searching && listPuntoInspeccion.length > 0" [saving]="saving" (porcentajeTotalValido)="porcentajeTotalEsValido = $event" [result]="listPuntoInspeccion"></app-porcentajesemanal-list-edit>

</div>



